import React from "react";
import ReactDOM from "react-dom";
import "./common/styles/reset.scss";
import "./index.scss";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./services/store";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
